export default "__VITE_ASSET__CXtzNncI__"